import { createContext } from 'react';
export var FedopsLoggerContext = createContext(null);
export var FedopsLoggerContextConsumer = FedopsLoggerContext.Consumer;
export var FedopsLoggerProvider = FedopsLoggerContext.Provider;
//# sourceMappingURL=FedopsLoggerProvider.js.map